import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    createEsubjectGoalLoading: false,
    createEsubjectGoalSuccess: {},
    createEsubjectGoalError: "",
    listEsubjectGoalLoading: false,
    listEsubjectGoalSuccess: {},
    listEsubjectGoalError: "",
    eSubjectGoalEditDetailsLoading: false,
    eSubjectGoalEditDetailsSuccess: {},
    eSubjectGoalEditDetailsError: '',
}

export const eSubjectGoalSlice = createSlice ({
    name: 'eSubjectGoal',
    initialState,
    reducers: {
        setCreateSubjectGoalLoading: (state, action) => {
            state.createEsubjectGoalLoading = true
        },
        setCreateSubjectGoalSuccess: (state, action) => {
            state.createEsubjectGoalLoading = false
            state.createEsubjectGoalSuccess = action.payload
        },
        setCreateSubjectGoalError: (state, action) => {
            state.createEsubjectGoalLoading = false
            state.createEsubjectGoalSuccess = {}
            state.createEsubjectGoalError = action.payload.message
        },
        setEsubjectGoalListLoading: (state, action) => {
            state.listEsubjectGoalLoading = true
        },
        setEsubjectGoalListSuccess: (state, action) => {
            state.listEsubjectGoalLoading = false
            state.listEsubjectGoalSuccess = action.payload
        },
        setEsubjectGoalListError: (state, action) => {
            state.listEsubjectGoalLoading = false
            state.listEsubjectGoalSuccess = {}
            state.listEsubjectGoalError = action.payload.message
        },
        setEsubjectGoalEditDetails: (state, action) => {
            state.eSubjectGoalEditDetailsLoading = true
        },
        setEsubjectGoalEditDetailsSuccess: (state, action) => {
            state.eSubjectGoalEditDetailsLoading = false
            state.eSubjectGoalEditDetailsSuccess = action.payload.data

        },
        setEsubjectGoalEditDetailsError: (state, action) => {
            state.eSubjectGoalEditDetailsLoading = false
            state.eSubjectGoalEditDetailsSuccess = {}
            state.eSubjectGoalEditDetailsError = action.payload.message
        },

        resetDetails: (state, action) => {
            state.createEsubjectGoalLoading = false
            state.createEsubjectGoalSuccess = {}
            state.createEsubjectGoalError = ""
            state.eSubjectGoalEditDetailsLoading = false
            state.eSubjectGoalEditDetailsSuccess = {}
            state.eSubjectGoalEditDetailsError = ""
        },
    }
})

export const {
    resetDetails,
    setCreateSubjectGoalLoading,
    setCreateSubjectGoalSuccess,
    setCreateSubjectGoalError,
    setEsubjectGoalListLoading,
    setEsubjectGoalListSuccess,
    setEsubjectGoalListError,
    setEsubjectGoalEditDetails,
    setEsubjectGoalEditDetailsSuccess,
    setEsubjectGoalEditDetailsError,
} = eSubjectGoalSlice.actions

export default eSubjectGoalSlice.reducer;

